module.exports = __webpack_public_path__ + "static/img/4.12db48f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-img/4.jpg
// module id = nVRt
// module chunks = 1